import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MemberService} from '@services/member.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {SeparatorComponent} from '@/app/shared/components/separator/separator.component';
import {MemberCardComponent} from '@components/member-card/member-card.component';
import {AsyncPipe} from '@angular/common';
import {AchievementService} from '@services/achievement.service';
import {Achievement} from '@/app/core/models/achievement';
import {AchievementRowComponent} from '@components/achievement-row/achievement-row.component';
import {UpcomingMatchsComponent} from '@components/upcoming-matchs/upcoming-matchs.component';
import {MatchService} from '@services/match.service';
import {TitleComponent} from '@/app/shared/components/title/title.component';
import {Title} from '@angular/platform-browser';
import {TranslatePipe} from '@ngx-translate/core';
import {LastVideosComponent} from '@components/last-videos/last-videos.component';
import {MemberTiny} from '@/app/core/models/member';
import {CalendarGroupByDate} from '@/app/core/models/calendar/calendarGroupByDate';
import {
	MemberMarvelRivalsCardComponent
} from '@components/member-marvel-rivals-card/member-marvel-rivals-card.component';

@Component({
  selector: 'app-roster-dofus',
	imports: [
		SeparatorComponent,
		AsyncPipe,
		AchievementRowComponent,
		UpcomingMatchsComponent,
		TitleComponent,
		TranslatePipe,
		LastVideosComponent,
		MemberMarvelRivalsCardComponent
	],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './roster-dofus.component.html',
})
export class RosterDofusComponent implements OnInit {

	constructor(
		private readonly memberService: MemberService,
		private readonly achievementService: AchievementService,
		private readonly matchService: MatchService,
		private readonly titleService: Title,
	) { }

	private readonly membersSubject = new BehaviorSubject<MemberTiny[]>([]);
	private readonly coachesSubstitutesSubject = new BehaviorSubject<MemberTiny[]>([]);

	members$: Observable<MemberTiny[]> = this.membersSubject.asObservable();
	coachesSubstitutes$: Observable<MemberTiny[]> = this.coachesSubstitutesSubject.asObservable();

	achievements: Achievement[] = [];

	matches: CalendarGroupByDate[] = [];

	ngOnInit(): void {
		this.loadMembers();
		this.loadAchievements();
		this.loadMatches();
	}

	loadMembers() {
		this.memberService.getActiveMembers('DOFUS').subscribe({
			next: (members) => {
				this.membersSubject.next(members['members']);
				this.coachesSubstitutesSubject.next([
					...members['substitutes'],
					...members['coaches']
				]);
			},
			error: (error) => {
				console.error('Error fetching members:', error);
			}
		});
	}

	loadAchievements() {
		this.achievementService.getAllAchievementByRosterType('DOFUS').subscribe({
			next: (achievements) => {
				this.achievements = achievements;
			},
			error: (error) => {
				console.error('Error fetching achievements:', error);
			}
		})
	}

	loadMatches() {
		this.matchService.getUpcomingMatchesByEventType('DOFUS').subscribe({
			next: (matches) => {
				this.matches = matches;
			},
			error: (error) => {
				console.error('Error fetching matches:', error);
			}
		})
	}
}
